import router from '@/router';

import { cacheCleanerService } from './cacheCleaner.service';

export default () => {
  cacheCleanerService();

  router.go('/auth');
};
